import { z } from 'zod';
import { currencySchema, itemPackingSchema, vehicleTypesSchema } from '../../common';
import { floatNumSchema, quantitySchema } from '../../validation';

const costTypeSchema = z.enum([
  'total', // ignores the quantity
  'perQuantity', // this multiples the item cost by quantity to get the total (this happens on client side)
]);
export type CostType = z.infer<typeof costTypeSchema>;

export const itemPreferencesSchema = z.object({
  /** the currency in which we calculate costs */
  currency: currencySchema,
  /** the vehicles that will be fit for this type of item*/
  vehicles: z.array(vehicleTypesSchema).min(1),
  /** the quantity of items such 24 pallets/packages/etc */
  quantity: quantitySchema.default(0),
  /** the quantity type / packing such as pallets, boxes , etc */
  packing: itemPackingSchema,
  /** the cost of item as per the quantity or total */
  cost: floatNumSchema.default(0),
  costType: costTypeSchema.default('total'),
});
export type ItemPreferences = z.infer<typeof itemPreferencesSchema>;
